<template>
  <div>
    <strong>Versão 7.0.0</strong>
    <ul>
      <li>
        Atualizamos o <strong>Vínculo e Acompanhamento</strong> de acordo com a
        Portaria GM/MS nº 3.493/2024 que descreve a nova metodologia de
        cofinanciamento federal da APS
      </li>
      <li>
        Inclusão do card <strong>Desempenho por Equipe</strong> que demonstra os
        dados consolidados de pessoas e o desempenho por equipe do vínculo e
        acompanhamento. Na aba Equipes é possível identificar a localização no
        mapa das equipes do município, bem como a quantidade mínima e máxima de
        pessoas por equipe. Essa funcionalidade auxilia na decisão sobre a
        necessidade de realizar ou não remapeamento para equilibrar a quantidade
        de pessoas por equipe.
      </li>
      <li>
        Atualizamos o card <strong>Cadastros Cidadãos</strong>, apresentando
        dados sobre a completude e atualização dos cadastros, considerando os
        cadastros individuais e domiciliares (FCI e FCDT). Foram inseridas as
        abas de Percentual e Escore.
      </li>
      <li>
        Atualizamos o card  <strong>Acompanhamento</strong>. Foram inseridas as
        abas de Percentual e Escore. O escore auxilia para mensurar a
        efetividade das ações realizadas pelas equipes de Atenção Primária à
        Saúde (APS)
      </li>
      <li>
        O escore apresenta a classificação da equipe conforme o vínculo e
        acompanhamento do cofinanciamento federal. Importante importar os
        cidadãos beneficiários do Bolsa Família no PEC ou PEC Centralizador para
        que o escore esteja o mais perto possível da classificação que a equipe
        vai ter no quadrimestre.
      </li>
    </ul>

    <strong>Versão 6.6.0</strong>
    <ul>
      <li>
        Atualizamos o <strong>CARD BPA E RAS</strong> com a capacidade de gerar
        o <strong>BPA (Consolidado e Individualizado)</strong>. As fichas
        <strong>BPA I</strong> e <strong>BPA C</strong> são utilizados para
        serem digitadas no SIA SUS. Agora é possível gerar essas fichas
        diretamente aqui para evitar o trabalho manual de processar elas.
      </li>
    </ul>

    <strong>Versão 6.5.0</strong>
    <ul>
      <li>
        Inclusão do CARD <strong>CEO</strong> que contem a produção por
        competência, bem como o monitoramento das metas por categoria de
        procedimentos executados. Essa funcionalidade é útil para os municípios
        que usam o e-SUS PEC CEO monitorarem sua produção.
      </li>
    </ul>

    <strong>Versão 6.4.0</strong>
    <ul>
      <li>
        Adequação das vacinas <strong>HPV</strong> (HPV e 0 – 15 ANOS) e
        <strong>Hepatite B</strong> (0 – 15 ANOS) ao calendário de vacinação
        definido pela "INSTRUÇÃO NORMATIVA DO CALENDÁRIO NACIONAL DE VACINAÇÃO
        2024".
      </li>
    </ul>

    <strong>Versão 6.3.0</strong>
    <ul>
      <li>
        Inclusão do Card <b>TRIA</b> que apresenta Triagem para Risco de
        Insegurança Alimentar (TRIA) na APS por família.
      </li>
    </ul>

    <strong>Versão 6.2.0</strong>
    <ul>
      <li>
        Inclusão do Card <b>Vínculo e acompanhamento</b> (Diagnóstico
        situacional, Cadastros, Acompanhamentos). Essa funcionalidade atende aos
        requisitos do componente de vínculo e acompanhamento do cofinanciamento
        federal da APS;
      </li>
      <li>
        No <b>cadastro</b>, é possível identificar os cidadãos que estão com e
        sem atualização do cadastro FCI, bem como em que medida de 0 a 100%, a
        FCI está ou não completa;
      </li>
      <li>
        No <b>acompanhamento</b> é possível identificar os cidadãos que estão
        com e sem acompanhamento (atendimento de medicina, enfermagem,
        procedimento, profissionais da eMulti, visitas dos ACS, atendimento
        odontológico ou atividade coletiva);
      </li>
      <li>
        No diagnóstico situacional é possível identificar a localização no mapa
        das equipes do município, bem como a quantidade mínima e máxima de
        pessoas por equipe. Essa funcionalidade ajuda na decisão sobre a
        necessidade de realizar ou não remapeamento para equilibrar a quantidade
        de pessoas por equipe.
      </li>
    </ul>

    <strong>Versão 6.0.0</strong>
    <ul>
      <li>
        Ajustes da home page para refletir os requisitos do cofinanciamento
        federal da APS;
      </li>
      <li>
        Inclusão na área de acesso público das funcionalidades: Mapa IED, Mapa
        UBS e Simulação;
      </li>
      <li>
        A simulação permite visualizar relatório com projeção dos repasses
        mensais e anuais de acordo com a classificação do município;
      </li>
      <li>
        O mapa UBS está sendo atualizado. Então se ainda não tiver disponível
        para seu município, pode aguardar que vai estar em breve;
      </li>
      <li>
        Tracejado no link Previne Brasil para indicar que foi descontinuado, mas
        as informações ficarão disponíveis ainda;
      </li>
      <li>
        Em breve, teremos outra versão com o CARD de Vínculo e Acompanhamento.
      </li>
    </ul>

    <strong>Versão 5.13.0</strong>
    <ul>
      <li>
        Inclusão de novos perfis: Coordenador(a) de Vigilância em Saúde,
        Coordenador(a) de Imunização, Técnico ou Auxiliar de Saúde Bucal,
        Vacinador(a) e Agente Comunitário de Endemias(a).
      </li>
    </ul>

    <strong> Versão 5.12.0</strong>

    <ul>
      <li>
        Inclusão do CARD <strong>Aedes Aegypti</strong> Atendimentos e visitas
        em cidadãos com presença do vetor transmissor da dengue. Os que estão
        vermelhos merecem atenção, pois são atendimentos recentes e podem
        indicar presença de foco.
      </li>
    </ul>

    <strong>Versão 5.11.0</strong>

    <ul>
      <li>
        Inclusão do CARD Gestão Cadastros >> Óbitos que apresenta a lista de
        cidadãos com informação de óbito no cadastro;
      </li>
      <li>
        Inclusão do CARD Gestão Cadastros >> Óbitos que apresenta a lista de
        cidadãos com informação de óbito no cadastro;
      </li>
    </ul>

    <strong>Versão 5.10.0</strong>

    <ul>
      <li>
        Alteração do CARD
        <strong>Imunização >> Vacina idade certa >> 0 – 2 anos</strong> PARA
        <strong>Imunização >> Vacina idade certa >> 0 – 15 anos.</strong>
        Com inteligência para identificar as crianças e adolescentes de 0 (zero)
        a 15 (quinze) anos de idade que estão com dose de vacinação em atraso;
      </li>
      <li>
        Inclusão do CARD <strong>Imunização >> Dose Imunizante</strong> que
        apresenta vacinas e doses preconizadas nos indicadores do PNI para as
        crianças de 0 (zero) a 15 (quinze) meses de idade;
      </li>
    </ul>

    <strong>Versão 5.9.0</strong>

    <ul>
      <li>
        Inclusão do CARD <strong>Produção >> Procedimentos</strong> que
        apresenta a possibilidade de exportar os procedimentos em um intervalo
        de 30 dias definido pelo usuário. É possível contar os procedimentos por
        UBS, por profissional, por CBO e outros. A exportação é feita em
        planilha excel que permite o tratamento e a implementação de outros
        filtros que usuário ache necessário;
      </li>
      <li>
        Inclusão do CARD
        <strong>Gestão Cadastros >> Calculadora de pessoas</strong>. Onde é
        possível visualizar a quantidade de pessoas por equipe e idade de forma
        que seja possível visualizar rapidamente e facilmente a quantidade de
        pessoas no território.
      </li>
    </ul>

    <strong>Versão 5.8.0</strong>

    <ul>
      <li>
        Alteração no filtro <strong>Último atendimento</strong> nos CARDS dos
        Indicadores na APS (Hipertensão e Diabetes) para
        <strong>visualizar atendimentos nos últimos 30 dias, 2 e 3 meses</strong
        >. Isso permite identificar atendimentos recentes e que não tiveram CID
        ou CIAP de hipertensão ou diabetes (estão vermelho na lista nominal), o
        que é sugestivo para necessidade de registro complementar via CDS a fim
        de qualificar o atendimento nos indicadores;
      </li>
      <li>
        Alteração no <strong>filtro idade para grupos</strong> no CARD
        <strong>Exames citopatológico</strong> para visualizar as mulheres com
        atendimentos recente, mas sem o registro do procedimento clínico de
        citopatológico (estão vermelhos na lista nominal), o que sugere
        realização do procedimento ou outro tipo de atendimento. Também poderia
        ter registro complementar no CDS para qualificar o atendimento ao
        indicador nos casos em que se teve a realização do citopatológico na
        UBS. Outra melhoria foi a Inclusão da data do último atendimento
        realizado na mulher.
      </li>
    </ul>

    <strong>Versão 5.7.4</strong>

    <ul>
      <li>
        Alteração do CARD <strong>Desempenho geral</strong> para mostrar na
        lista as equipes que estão com denominador zerado em pré-natal ou
        crianças de um ano no indicador de imunização para o quadrimestre
        avaliado;
      </li>
      <li>
        Alteração dos <strong>Resultados</strong> nos CARDS:
        <strong
          >Citopatológico, Atendimento Hipertensão e Atendimento
          Diabetes</strong
        >
        para mostrar o resultado a nível municipal de acordo com a atualização
        disponibilizada SISAB no quadrimestre atual. Essa otimização vai
        aumentar a precisão em relação ao resultado liberado no SISAB;
      </li>
      <li>
        Alteração do <strong>Resultado</strong> no CARD
        <strong>Cidadãos visitados</strong> para mostrar a quantidade
        relacionada a porcentagem.
      </li>
    </ul>

    <strong>Versão 5.7.3</strong>

    <ul>
      <li>
        Alteração do CARD <strong>Cadastros cidadãos</strong> para incluir a
        quantidade de cidadãos atualizados e quantidade de cidadãos
        desatualizados. Os resultados SISAB irão ficar incluídos no gráfico de
        barras.
      </li>
    </ul>

    <strong>Versão 5.7.2</strong>

    <ul>
      <li>
        Alteração no CARD <strong>Envio APP ACS PEC</strong> para que a
        <strong>Última visita</strong> mostre a maior data entre as visitas
        registradas, em vez de o último registro. Essa melhoria é para atender
        cidades que usam aplicativos de terceiros ou próprios (SISTEMA EXTERNO);
      </li>
    </ul>

    <strong>Versão 5.7.1</strong>

    <ul>
      <li>
        Foi incluído no CARD <strong>Envio APP ACS PEC</strong> as colunas:
        <strong>Fichas visitas</strong> (quantidade de fichas produzidas pelo
        ACS), <strong>Média equipe</strong> (média das fichas das visitas
        produzidas pelos ACS da equipe) e
        <strong>Média municipal</strong> (média das fichas de visitas produzidas
        no município).
        <strong
          >As quantidades dessas colunas contem dados dos últimos 30 dias a
          contar de hoje para trás.</strong
        >
      </li>
    </ul>

    <strong>Versão 5.7.0</strong>

    <ul>
      <li>
        No CARD <strong>Administração</strong>, foi criado o CARD
        <strong>Alterar logotipo</strong> que permite mudar a logo que aparece
        antes do nome da cidade na versão Web. Para ter acesso a essa
        funcionalidade, faz-se necessário solicitar ativação dela ao suporte do
        eSUS Feedback.
      </li>
      <li>
        No CARD <strong>Relatório atendimentos</strong>, foi incluído também
        para a <strong>Ação Detalhar</strong>, o quantitativo por turno, quando
        o profissional de saúde é o Técnico ou Auxiliar de Enfermagem. Foi
        incluído também o <strong>botão de ajuda</strong> (?) com informações
        importantes.
      </li>
    </ul>

    <strong>Versão 5.6.6</strong>
    <ul>
      <li>
        Alteração do nome do CARD <strong>Comorbidades</strong> para
        <strong>Condições Saúde</strong> e ajuste nos nomes dos filtros de
        hipertensão, diabetes e problemas de saúde mental;
      </li>
      <li>
        No CARD <strong>Visitas domiciliares</strong>, foi corrigido o mapa para
        mostrar a localização das visitas que são registradas com
        georreferenciamento a partir do aplicativo dos ACS.
      </li>
    </ul>
    <strong>Versão 5.6.5</strong>
    <ul>
      <li>
        Disponibilidade do CARD <strong>Comorbidades</strong> que apresenta as
        condições de saúde por cidadão;
      </li>
      <li>
        No CARD <strong>Relatório atendimentos</strong>, foi incluída a busca
        por <strong>UBS</strong> e dentro da busca, pode ser realizado a
        filtragem pelas <strong>Equipes</strong> vinculadas a UBS. Isso é útil
        para os estabelecimentos que tem mais de uma equipe;
      </li>
      <li>
        No CARD <strong>Relatório atendimentos</strong>, quando se acessa a
        <strong>Ação Detalhar</strong>, então é possível incluir um filtro por
        data específica dentro do período dos últimos 90 dias;
      </li>
      <li>
        Quando o médico(a), enfermeiro(a) ou odontólogo(a) acessa o sistema, ele
        vai poder escolher a equipe que deseja visualizar os dados. Isso é útil
        para os profissionais que tem mais de uma lotação cadastrada dentro do
        e-SUS PEC ou Centralizador.
      </li>
    </ul>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
